import React from 'react';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import DetailSearchForm from '../Home/DetailSearchForm/DetailSearchForm';
import HomeSlider from './HomeBannerSlider';

import s from './homeBanner.css';
import bt from '../../components/Home/Layout4/Layout4.css'


const HomeBanner = ({ homeBannerImages, title, content, isLoading }) => {
    return (
        <>
            <div className='homeBannerLayout3SliderContainer'>
                <div className={s.homeBannerForm}>
                    <div className={bt.searchFormContainer}>
                        <div className={cx(s.formWrap)}>
                            <h1><span>{title}</span>
                                {' '} <span>{content}</span>
                            </h1>
                            <DetailSearchForm isLoading={isLoading} />
                        </div>
                    </div>
                </div>
                <HomeSlider homeBannerImages={homeBannerImages} />
            </div>
        </>
    )
}

export default compose(withStyles(s, bt))(HomeBanner);